export enum MouseButton {
    left = 0,
    middle = 1
}
